/**
 * Product detail tab switcher (mock .product-tabs).
 */
class ProductPageTabs extends HTMLElement {
  connectedCallback() {
    this.#buttons = this.querySelectorAll('[data-product-tab]');
    this.#panels = this.querySelectorAll('[data-product-tab-panel]');
    if (!this.#buttons.length) return;

    this.#buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.#activate(btn));
    });
  }

  /** @type {NodeListOf<HTMLButtonElement>} */
  #buttons;
  /** @type {NodeListOf<HTMLElement>} */
  #panels;

  /** @param {HTMLButtonElement} btn */
  #activate(btn) {
    const id = btn.dataset.productTab;
    if (!id) return;

    this.#buttons.forEach((b) => {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.#panels.forEach((panel) => {
      const active = panel.dataset.productTabPanel === id;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

if (!customElements.get('product-page-tabs')) {
  customElements.define('product-page-tabs', ProductPageTabs);
}
